export default __webpack_public_path__ + "static/PromptIconThree-11006308776a197a7bf0caae3b63a397.png";